// Import React modules
import React, { useState, useEffect } from "react";
// Import other modules
import {
  doc,
  getDoc,
  updateDoc,
  collection,
  query,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";
// Import Firebase config
import { auth, db } from "../firebase";
// Import CSS stylesheets
import "../styles/variables.css";
import "../styles/layoutStyles.css";
import "../styles/buttonStyles.css";
import "../styles/textStyles.css";

function SearchTabContent() {
  // State declarations

  return (
    <div className="box-sizing-default">
      <h2>Search Guidelines</h2>
      <p>
        Motics Search Guidelines allows you to search for treatment recommendations
        based on the latest NICE guidelines.
      </p>
      <p>
        It is currently in BETA. Please click the button below to access Motics
        Search Guidelines.
      </p>
      <div
        className="box-sizing-default"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "3rem",
        }}
      >
        <button
          className="button-classic"
          style={{ width: "auto" }}
          onClick={() => window.open("https://search.motics.ai/", "_blank")}
        >
          Access Motics Search Guidelines
        </button>
        <div className="box-sizing-default small-text" style={{marginTop:"1rem"}}>
          This will open a new tab on your browser.
        </div>
      </div>
    </div>
  );
}

export default SearchTabContent;
